import {
  AiCodingType,
  BaseResponse, MfdsProductAiCodeRetrieveResponse, MfdsProductCodingListRetrieveResponse, MfdsProductCodingUpdateResponse,
  MfdsProductRecommendedCodeInfoResponse, MfdsSubstanceAiCodeRetrieveResponse, MfdsSubstanceCodingListRetrieveResponse,
  MfdsSubstanceCodingUpdateResponse,
  MfdsSubstanceRecommendedCodeInfoResponse,
  ProductCodingListRetrieveResponse,
  ProductCodingUpdateResponse,
  ProductRecommendedCodeInfoResponse,
  WhoddAiCodeRetrieveResponse, WhoddSubstanceAiCodeRetrieveResponse, WhoddSubstanceCodingListRetrieveResponse,
  WhoddSubstanceCodingUpdateResponse,
  WhoddSubstanceRecommendedCodeInfoResponse, WhoddVersionRetrieveResponse
} from '@/model/CommonModel';
import axios, { AxiosResponse } from 'axios';

export default class AiCodingApi {
  public static retrieveRecommendedWhoddCodes(caseKey: number, rowNo: number, params: any = {}): Promise<WhoddAiCodeRetrieveResponse> {
    return axios
      .get(`/1.0/ai-coding/recommended-codes/WHODD/cases/${caseKey}/${rowNo}`, {params})
      .then((res: AxiosResponse) => res.data);
  }

  public static retrieveProductCodes(params: {}): Promise<ProductCodingListRetrieveResponse> {
    return axios.get(`/1.0/ai-coding/products`, {params})
      .then(res => res.data);
  }

  public static updateProductCodes(params: {}): Promise<ProductCodingUpdateResponse> {
    return axios.put(`/1.0/ai-coding/recommended-codes/WHODD/update`, params)
      .then(res => res.data);
  }

  public static retrieveWhoddVersion(): Promise<WhoddVersionRetrieveResponse> {
    return axios.get('/1.0/ai-coding/whodd-version')
      .then(res => res.data);
  }

  public static retrieveWhoddCode(whoddCode: string | number): Promise<ProductRecommendedCodeInfoResponse> {
    return axios.get(`/1.0/ai-coding/recommended-codes/WHODD/${whoddCode}`)
      .then(res => res.data);
  }

  public static retrieveAiCodingStatus(sponsorKey: number | string, aiCodingType: AiCodingType): Promise<BaseResponse> {
    return axios.get(`/1.0/ai-coding/recommended-codes/${aiCodingType}/sponsors/${sponsorKey}/check-status`)
      .then(res => res.data);
  }

  public static retrieveRecommendedWhoddSubstanceCodes(
    caseKey: number, rowNo: number, rowNo2: number, params: any = {}
  ): Promise<WhoddSubstanceAiCodeRetrieveResponse> {
    return axios
      .get(`/1.0/ai-coding/recommended-codes/WHODD_SUBS/cases/${caseKey}/${rowNo}/${rowNo2}`, {params})
      .then((res: AxiosResponse) => res.data);
  }

  public static retrieveWhoddSubstanceCodes(params: {}): Promise<WhoddSubstanceCodingListRetrieveResponse> {
    return axios.get(`/1.0/ai-coding/substances`, {params})
      .then(res => res.data);
  }

  public static updateWhoddSubstanceCodes(params: {}): Promise<WhoddSubstanceCodingUpdateResponse> {
    return axios.put(`/1.0/ai-coding/recommended-codes/WHODD_SUBS/update`, params)
      .then(res => res.data);
  }

  public static retrieveWhoddSubstanceCode(casCode: string | number): Promise<WhoddSubstanceRecommendedCodeInfoResponse> {
    return axios.get(`/1.0/ai-coding/recommended-codes/WHODD_SUBS/${casCode}`)
      .then(res => res.data);
  }

  public static retrieveRecommendedMfdsProductCodes(
    caseKey: number, rowNo: number, params: any = {}
  ): Promise<MfdsProductAiCodeRetrieveResponse> {
    return axios
      .get(`/1.0/ai-coding/recommended-codes/MFDS/cases/${caseKey}/${rowNo}`, {params})
      .then((res: AxiosResponse) => res.data);
  }

  public static retrieveMfdsProductCodes(params: {}): Promise<MfdsProductCodingListRetrieveResponse> {
    return axios.get(`/1.0/ai-coding/MFDS/products`, {params})
                .then(res => res.data);
  }

  public static updateMfdsProductCodes(params: {}): Promise<MfdsProductCodingUpdateResponse> {
    return axios.put(`/1.0/ai-coding/recommended-codes/MFDS/update`, params)
                .then(res => res.data);
  }

  public static retrieveMfdsProductCode(drugCode: string | number): Promise<MfdsProductRecommendedCodeInfoResponse> {
    return axios.get(`/1.0/ai-coding/recommended-codes/MFDS/${drugCode}`)
                .then(res => res.data);
  }

  public static retrieveRecommendedMfdsSubstanceCodes(
    caseKey: number, rowNo: number, rowNo2: number, params: any = {}
  ): Promise<MfdsSubstanceAiCodeRetrieveResponse> {
    return axios
      .get(`/1.0/ai-coding/recommended-codes/MFDS_SUBS/cases/${caseKey}/${rowNo}/${rowNo2}`, {params})
      .then((res: AxiosResponse) => res.data);
  }

  public static retrieveMfdsSubstanceCodes(params: {}): Promise<MfdsSubstanceCodingListRetrieveResponse> {
    return axios.get(`/1.0/ai-coding/MFDS_SUBS/substances`, {params})
                .then(res => res.data);
  }

  public static updateMfdsSubstanceCodes(params: {}): Promise<MfdsSubstanceCodingUpdateResponse> {
    return axios.put(`/1.0/ai-coding/recommended-codes/MFDS_SUBS/update`, params)
                .then(res => res.data);
  }

  public static retrieveMfdsSubstanceCode(drugCode: string | number): Promise<MfdsSubstanceRecommendedCodeInfoResponse> {
    return axios.get(`/1.0/ai-coding/recommended-codes/MFDS_SUBS/${drugCode}`)
                .then(res => res.data);
  }

  public static retrieveRecommendedMeddraCodes(caseKey: number, rowNo: number, params: {}) {
    return axios.get(`/1.0/ai-coding/recommended-codes/MEDDRA/cases/${caseKey}/${rowNo}`, {params})
        .then(res => res.data);
  }

}
